<template>
  <v-container>
    <v-row class="pb-4">
      <v-col>
        <v-icon> mdi-hospital-building </v-icon>
        <span class="headline mx-2">Company Access</span>
      </v-col>
    </v-row>
    <v-row
      v-if="loading" 
      class="fill-height"
      
      align="center" 
      justify="center"
    >
      <v-progress-circular
        indeterminate
        color="primary"
      />
    </v-row>
    <div v-else>
      <v-row 
        v-if="noOfCompanies > 0"
      >
        <v-col 
          v-for="company in filteredCompanyBranches"
          :key="company.id"
          cols="12"
          md="6" 
          lg="4"
        >
          <v-card>
            <v-card-actions>              
              <span class="body-2 font-weight-regular"> {{ company.name }} {{ company.schema_name ? '('+company.schema_name+')' : '' }} </span>
              <v-spacer />
              <v-btn 
                icon 
                @click="onClickHandler(company.id)"
              >
                <v-icon>{{ shows[company.id] ? 'keyboard_arrow_down' : 'keyboard_arrow_up' }}</v-icon>
              </v-btn>
            </v-card-actions>

            <v-slide-y-transition>
              <div v-show="shows[company.id]">
                <v-divider class="company" />
                <v-list dense>
                  <v-list-item 
                    v-for="branch in company.branches" 
                    :key="branch.branch_uid"
                  >
                    <v-list-item-content class="font-weight-light">
                      {{ branch.branch_name }}
                    </v-list-item-content>
                  </v-list-item>
                </v-list>
              </div>            
            </v-slide-y-transition>
          </v-card>
        </v-col>        
      </v-row>
      <v-row v-else>
        <v-col>
          <span class="mx-2"> No data available </span>
        </v-col>
      </v-row>

      <div v-if="noOfCompanies >= 7">
        <a 
          v-if="filter" 
          @click.stop="filter = false"
        >Show more ...</a> 
        <a 
          v-else 
          @click.stop="filter = true"
        >Show less ...</a>
      </div>
    </div> 
    <v-card-actions v-show="$hasPermissionTo(['assign branch access section']) && !$store.state.isMyProfile">
      <v-spacer />
      <user-companies-dialog-edit 
        :user-uid="userUid"
        @updated="loadUserCompanyAcess()"
      />
      <span class="mx-1" />
      <user-companies-dialog-edit-non-m-l-company
        :user-uid="userUid"
        @updated="loadUserCompanyAcess()"
      />
    </v-card-actions>
  </v-container>
</template>

<script>
  export default {
    components: {
      UserCompaniesDialogEdit: () => import('@/components/user/companies/DialogEdit'),
      UserCompaniesDialogEditNonMLCompany: () => import('@/components/user/companies/DialogEditNonMLCompany'),
    },
    props: {
      userUid: {
        type: String,
        required: true,
      },
    },
    data () {
      return {
        shows: [],
        filter: true,
        loading: false,
        progressing: false,
        companies: [],
        branches: [],
        companyBranches: [],
      }
    },
    computed: {
      noOfCompanies () {
        return this.companyBranches.length
      },
      filteredCompanyBranches () {
        if (this.noOfCompanies < 7) return this.companyBranches

        return this.filter ? this.companyBranches.slice(0, 6) : this.companyBranches
      },
    },
    watch: {
      userUid: {
        immediate: true,
        handler (value) {
          if (value) {
            this.$resetData()
            this.loadUserCompanyAcess()
          }
        },
      },
    },
    methods: {
      loadUserCompanyAcess () {
        this.loading = true

        Promise.all([
          this.$api.userCompanies().list(this.userUid),
          this.$api.userBranches().list(this.userUid),
        ])      
          .then(([companies, branches]) => {
            this.companies = companies.data
            this.branches = branches.data
          
            this.computeData()
          })
          .catch(() => {})
          .then(() => {
            this.loading = false
          })
      },
      onClickHandler (id) {
        this.$set(this.shows, id, !this.shows[id])
      },
      computeData () {
        this.companyBranches = this.companies.map(company => {
          let branches = this.branches.filter(branch => {
            return branch.company_uid === company.id
          })

          return { ...company, branches: branches }
        })
      },
    },
  }
</script>
<style>
.theme--light.v-divider.company {
  border-color: rgb(216, 207, 207) !important;
}

</style>
